import AccessibleAlert from '@reach/alert';
import React from 'react';
import {Message, MessageProps} from 'semantic-ui-react';

export const Alert = (props: MessageProps) => (
  <Message {...props} as={AccessibleAlert} />
);
